import { memo } from 'react';
import Markup, { bodyClass } from './SectorMarkup';
import { usePage, useLegacyController } from '../hooks/usePage';

// Static markup is memoised so React never re-renders over the DOM the live controller updates.
const PageMarkup = memo(Markup);

export default function SectorPatrol() {
  usePage({ title: 'Travelling Supervisory Officer Portal - Live Moving Booth Tracking', bodyClass });
  useLegacyController(() => import('../legacy/sector.js'));
  return <PageMarkup />;
}
